import { combineReducers } from 'redux';
import loggedUserReducer from './loggedUserReducer';
import ticketsQuotesReducer from './ticketsQuotesReducer';
import securityReducer from './securityReducer';
import createJobReducer from './createJobReducer';
import recentActivityCalendarReducer from './recentActivityCalendarReducer';
import calendarReducer from './calendarReducer';

// Combines all reducers to a single reducer function
const rootReducer = combineReducers({
    loggedUserState:loggedUserReducer,
    calendarState:calendarReducer,
    recentActivityCalendarState:recentActivityCalendarReducer,
    ticketsQuotesState:ticketsQuotesReducer,
    securityState:securityReducer,
    createJobState: createJobReducer
});

export default rootReducer;